import { render, staticRenderFns } from "./ProfileStatsPanel.vue?vue&type=template&id=0d9f1158&"
import script from "./ProfileStatsPanel.vue?vue&type=script&lang=js&"
export * from "./ProfileStatsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports